import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../../common/SharedComponents';

import LoansApprovedRoutes from './components/LoansApprovedRoutes';
import LoansLostRoutes from './components/LoansLostRoutes';
import LoansOutstandingRoutes from './components/LoansOutstandingRoutes';
import LoansRepaidRoutes from './components/LoansRepaidRoutes';
import RecycleBinLandingPage from '../../../../loans/RecycleBinLandingPage';

export default function LoanRoutes() {
    return (
        <>
            {LoansApprovedRoutes()}
            {LoansOutstandingRoutes()}
            {LoansRepaidRoutes()}
            {LoansLostRoutes()}
            <Route
                path='/loans/recyclebin'
                element={
                    <RequireAdmin>
                        <RecycleBinLandingPage />
                    </RequireAdmin>
                }
            />
        </>
    );
}
